const listeners = new Set();
let active = false;

export function setExplainerActive(value) {
  active = Boolean(value);
  listeners.forEach((cb) => {
    try {
      cb(active);
    } catch (e) {
      console.warn("[explainerEvents] listener error:", e);
    }
  });
}

export function isExplainerActive() {
  return active;
}

export function onExplainerChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}